// Cloud Projects — tokens de marca PwC, versión JS para props de recharts (spec 010, plan.md §3.1).
//
// Misma fuente y mismos valores que ./brand-tokens.css — los DOS archivos se editan juntos (R-7).
// Por qué existe un segundo archivo en vez de reusar `var(--cp-*)` en los props de gráfica: en SVG puro
// `fill="var(--x)"` resuelve, pero recharts calcula algunos colores en JS (cursor del tooltip,
// degradados, activeDot) y ahí la custom property llega como string sin resolver -> la gráfica se pinta
// en negro (R-8). Duplicar diez hexes en un módulo declarado es más barato y más predecible que perseguir
// ese bug.
//
// Cero hexes literales fuera de este archivo y de brand-tokens.css (CA-11).
export const VIZ = {
  // Escala de naranjas de la marca (decisión de Leonel, 2026-08-09). Validada con el script de la skill
  // `dataviz`: rampa ordinal de 5 pasos PASS, par serie/serie2 PASS (ΔE 31.6 con daltonismo).
  serie: "#C04502", // serie única: todas las barras de una distribución sin orden natural.
  // Es el paso 3, no el #FE7C39 del paso 1: ese es el hover del botón principal y una barra
  // no puede leerse como un control.
  serie2: "#2563EB", // segunda categoría nominal en la misma marca (no hay un tercer color, §6 skill)
  // Rampa ordinal: SOLO escalas ordenadas (embudo, tiers). Arranca en el naranja de marca; no se puede
  // aclarar más (#FFAA72 solo da 1.87:1 contra blanco, bajo el piso de 2:1).
  rampa: ["#FE7C39", "#E85D0F", "#C04502", "#8F3200", "#5C2000"],
  grid: "#E6E7E9",
  axis: "#C9CBCF",
  track: "#E6E7E9",
  ink: "#111113",
  ink2: "#626771",
  inkInverse: "#FFFFFF", // texto sobre fondo de estado sólido
};

export default VIZ;
